import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var ClickStar = /*#__PURE__*/function (_Component) {
  _inherits(ClickStar, _Component);

  var _super = _createSuper(ClickStar);

  function ClickStar() {
    var _this;

    _classCallCheck(this, ClickStar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      starIndex: _this.props.starIndex,
      clickedStarIndex: _this.props.starIndex
    });

    _defineProperty(_assertThisInitialized(_this), "onStarClicked", function (index) {
      _this.setState({
        starIndex: index,
        clickedStarIndex: index
      });

      if (_this.props.onRatingClicked) {
        _this.props.onRatingClicked(index);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getStarInfo", function (index) {
      var starRatingInfo = _this.props.starRatingInfo;
      if (index === 0) return '';
      return starRatingInfo.length > 0 ? starRatingInfo[index - 1] : '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (index) {
      _this.setState({
        starIndex: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      var clickedStarIndex = _this.state.clickedStarIndex;

      _this.setState({
        starIndex: clickedStarIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderStars", function () {
      var starCount = _this.props.starRatingInfo.length;
      var starIndex = _this.state.starIndex;

      var starClassNames = function starClassNames(i, starI) {
        return starI >= i ? 'click-star__click icon icon-star icon-yellow' : 'click-star__click icon icon-star-o icon-yellow';
      };

      var stars = [];

      var _loop = function _loop(i) {
        stars.push(
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        React.createElement("span", {
          key: "star-".concat(i),
          className: starClassNames(i, starIndex),
          onClick: function onClick() {
            return _this.onStarClicked(i);
          },
          onMouseEnter: function onMouseEnter() {
            return _this.handleMouseEnter(i);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.handleMouseLeave(i);
          },
          style: {
            cursor: 'pointer'
          }
        }, "\xA0"));
      };

      for (var i = 1; i <= starCount; i += 1) {
        _loop(i);
      }

      stars.push( /*#__PURE__*/React.createElement("span", {
        key: "starInfo",
        className: "click-star__info click-star__info--visible"
      }, _this.getStarInfo(starIndex)));
      return stars;
    });

    return _this;
  }

  _createClass(ClickStar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "rating"
      }, this.renderStars());
    }
  }]);

  return ClickStar;
}(Component);

ClickStar.displayName = "ClickStar";

_defineProperty(ClickStar, "propTypes", {
  starRatingInfo: PropTypes.arrayOf(PropTypes.string),
  starIndex: PropTypes.number.isRequired,
  onRatingClicked: PropTypes.func.isRequired
});

_defineProperty(ClickStar, "defaultProps", {
  starRatingInfo: ['Very poor', 'Poor', 'OK', 'Good', 'Excellent']
});

export { ClickStar as default };